import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import ContactPageForm from "../../components/ContactPageForm/ContactPageForm";
import FreeEstimateForm from "../../components/FreeEstimateForm/FreeEstimateForm";

const FreeEstimate = () => {
  return (
    <>
        <Helmet>
        <title>Free Estimate | Marion County, FL | Watkins Seamless Gutters</title>
        <meta
            name="description"
            content="Request your free gutter estimate from Watkins Seamless Gutters. Serving Marion, Lake, and Sumter Counties, we provide seamless gutter installation, repairs, and protection systems. Call 352-812-0831 today."
        />

        {/* === Open Graph / Twitter === */}
        <meta name="twitter:card" content="summary" />
        <meta
            name="twitter:title"
            content="Free Estimate | Marion County, FL | Watkins Seamless Gutters"
        />
        <meta
            name="twitter:description"
            content="Get a free gutter estimate today. Watkins Seamless Gutters proudly serves Marion, Lake, and Sumter Counties in Florida."
        />

        <meta
            property="og:title"
            content="Free Estimate | Marion County, FL | Watkins Seamless Gutters"
        />
        <meta
            property="og:description"
            content="Request a free gutter estimate today from Watkins Seamless Gutters — serving Marion, Lake, and Sumter Counties, FL. Call 352-812-0831."
        />
        <meta
            property="og:url"
            content="https://www.watkinsgutters.com/free-estimate"
        />
        <meta
            property="og:type"
            content="website"
        />

        <link
            rel="canonical"
            href="https://www.watkinsgutters.com/free-estimate"
        />

        {/* === Schema.org Markup === */}
        <script type="application/ld+json">
            {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "serviceType": "Free Gutter Estimate",
            "provider": {
                "@type": "LocalBusiness",
                "name": "Watkins Seamless Gutters",
                "url": "https://www.watkinsgutters.com/free-estimate",
                "telephone": "352-812-0831",
                "email": "GuttersByWatkins@gmail.com",
                "address": {
                "@type": "PostalAddress",
                "addressLocality": "Marion County",
                "addressRegion": "FL",
                "addressCountry": "US"
                },
                "areaServed": {
                "@type": "Place",
                "name": [
                    "Sumter County, FL",
                    "Marion County, FL",
                    "Lake County, FL",
                    "Ocala, FL",
                    "Ocklawaha, FL",
                    "Summerfield, FL",
                    "Leesburg, FL",
                    "The Villages, FL"
                ]
                },
                "sameAs": ["https://www.facebook.com/GuttersByWatkins"],
                "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "352-812-0831",
                "contactType": "Customer Service",
                "availableLanguage": ["English"],
                "areaServed": [
                    "Sumter County, FL",
                    "Marion County, FL",
                    "Lake County, FL",
                    "Ocala, FL",
                    "Ocklawaha, FL",
                    "Summerfield, FL",
                    "Leesburg, FL",
                    "The Villages, FL"
                ]
                }
            },
            "description":
                "Watkins Seamless Gutters offers free estimates for seamless gutter installation, repair, and guard protection throughout Marion, Lake, and Sumter Counties in Florida.",
            "offers": {
                "@type": "Offer",
                "url": "https://www.watkinsgutters.com/free-estimate",
                "category": "Gutter Installation Estimate",
                "description":
                "Request a free, no-obligation quote for seamless gutter installation or protection in Marion, Sumter, and Lake Counties, FL."
            }
            })}
        </script>
        </Helmet>


      <div className="page-wrapper">
        <div className="page-content-container">
          <div className="content-wrapper">
            <div className="page-content">
              <div className="page-content-wrapper">
                <div className="page-title-wrapper">
                  <div className="page-title">
                    <h1>Request a Free Gutter Estimate</h1>
                  </div>

                  <div className="content-columns-wrapper">
                    <div className="content-column">
                      <div className="section-content" style={{ marginTop: 0 }}>
                        <h2>Quality Work, Transparent Pricing</h2>
                        <p>
                          When it comes to gutter installation and protection,
                          it’s important to work with a reliable, skilled, and
                          local team. At <strong>Watkins Seamless Gutters</strong>, we take pride in
                          providing exceptional service across Marion, Lake, and
                          Sumter Counties of Florida.
                        </p>
                      </div>

                      <div className="section-content" style={{ marginTop: "25px" }}>
                        <h2>How It Works</h2>
                        <ul>
                          <li>Fill out the quick form on this page</li>
                          <li>Our team will contact you within 24 hours</li>
                          <li>Schedule your on-site evaluation</li>
                          <li>Receive your personalized, no-obligation quote</li>
                        </ul>
                      </div>

                      <div className="section-content" style={{ marginTop: "25px" }}>
                        <h2>Before You Book</h2>
                        <p>
                          Have questions? Contact us directly on{" "}
                          <Link to="/contact" className="link-inline secondary">
                            our contact page
                          </Link>
                          {" "}
                          or browse our
                          <Link to="/gallery" className="link-inline secondary">
                            project gallery
                          </Link>{" "}
                          for inspiration and examples of our seamless gutter
                          and gutter guard installations.
                        </p>
                      </div>
                    </div>

                    {/* --- Form Column --- */}
                    <div className="form-background">
                      <div className="form-container">
                        <h3 className="form-title">Free Estimate Form</h3>
                        <div className="form-content-wrapper">
                          <FreeEstimateForm apiUrl={process.env.REACT_APP_API_URL} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FreeEstimate;